var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14C28 21.732 21.732 28 14 28C12.5875 28 11.2239 27.7908 9.93844 27.4018C8.98016 27.1659 8.08009 26.782 7.26382 26.2759C2.93415 23.895 0 19.2901 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14ZM2.85973 17.7118C2.80338 17.2698 2.77435 16.8194 2.77435 16.3623C2.77435 10.4049 7.70671 5.5755 13.7911 5.5755C19.8755 5.5755 24.8078 10.4049 24.8078 16.3623C24.8078 21.6857 20.8695 26.1084 15.6901 26.9895C19.1077 25.6018 21.5177 22.2488 21.5177 18.333C21.5177 13.1751 17.3364 8.99386 12.1786 8.99386C7.22941 8.99386 3.17941 12.8436 2.85973 17.7118ZM14.5698 12.3383C17.802 12.3383 20.4222 14.9585 20.4222 18.1906C20.4222 21.4228 17.802 24.043 14.5698 24.043C11.3377 24.043 8.71747 21.4228 8.71747 18.1906C8.71747 14.9585 11.3377 12.3383 14.5698 12.3383Z",
    fill: "#48C0B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.0e3e5c08548a07a7ef1a037c7c5a3ef9.svg";
export { ForwardRef as ReactComponent };